import React, { useMemo } from 'react';
import { BasicInfoCollapse } from '../../../../../../../components';
import { MemoryCriteria } from '../../../../components/DiscoveryInventoryTable/components/StorageAndMemoryCriteria/MemoryCriteria';
import { InfoRow } from '../../../../../../../components';
import { parseCpuData } from '../../../../../../../lib/helpers';
import { getCriteriaIcon } from '../../../../components/DiscoveryInventoryTable/components/StorageAndMemoryCriteria/CriteriaIcons';

export const SystemInformation = ({ record }) => {
    const cpusObject = parseCpuData(record?.cpus);
    const numberOfVCpus = cpusObject?.cores && cpusObject?.sockets ? cpusObject.cores * cpusObject.sockets : null;

    const cpu = {
        label: 'CPU',
        value: numberOfVCpus != null ? `${numberOfVCpus} ${numberOfVCpus === 1 ? 'vCPU' : 'vCPUs'}` : 'N/A',
    };
    const platform = { label: 'Platform', value: 'N/A' };
    const architecture = { label: 'Architecture', value: record?.architecture };
    const os = { label: 'OS', value: record?.os_type };

    return (
        <BasicInfoCollapse title="System Information" greyHeader={true}>
            <InfoRow
                label={cpu.label}
                value={
                    <>
                        {cpu.value} {getCriteriaIcon(record?.cpu_utilization)}
                    </>
                }
            />
            <MemoryCriteria criteria={record?.ram_utilization} total={record?.ram_total} used={record?.ram_used} />
            <InfoRow label={platform.label} value={platform.value} />
            <InfoRow label={architecture.label} value={architecture.value} />
            <InfoRow label={os.label} value={os.value} />
        </BasicInfoCollapse>
    );
};
